import { gql } from 'apollo-angular';

export const ACTIONS_LIST_QUERY = gql`
  query Action {
    actions {
      data {
        items {
          action
          dueDate
          highPriority
          id
          message
          accountId
          serviceIds
          siteIds
          entityType
          entityId
          subject
          snowLink
        }
      }
      isSuccess
      message
    }
  }
`;
